<ng-container [ngSwitch]="type">

    <ng-template ngSwitchCase="info">
        <i [pTooltip]="buildTooltip(record)"
           [tooltipPosition]="tooltipPosition"
           [escape]="escape"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons info">info</i>
    </ng-template>

    <ng-template ngSwitchCase="critical">
        <i [pTooltip]="buildTooltip(record)"
           [escape]="escape"
           [tooltipPosition]="tooltipPosition"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon critical">warning</i>
    </ng-template>

    <ng-template ngSwitchCase="alert">
        <i [pTooltip]="buildTooltip(record)"
           [escape]="escape"
           [tooltipPosition]="tooltipPosition"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon alert">warning</i>
    </ng-template>

    <ng-template ngSwitchCase="warning">
        <i [pTooltip]="buildTooltip(record)"
           [tooltipPosition]="tooltipPosition"
           [escape]="escape"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon warning-icon">warning</i>
    </ng-template>

    <ng-template ngSwitchCase="important">
        <i [pTooltip]="buildTooltip(record)"
           [escape]="escape"
           [tooltipPosition]="tooltipPosition"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon important-icon">warning</i>
    </ng-template>

    <ng-template ngSwitchCase="light">
        <i [pTooltip]="buildTooltip(record)"
           [escape]="escape"
           [tooltipPosition]="tooltipPosition"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon light">info</i>
    </ng-template>

    <ng-template ngSwitchCase="dark">
        <i [pTooltip]="buildTooltip(record)"
           [tooltipPosition]="tooltipPosition"
           [escape]="escape"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon dark">info</i>
    </ng-template>

    <ng-template ngSwitchCase="success">
        <i [pTooltip]="buildTooltip(record)"
           [escape]="escape"
           [tooltipPosition]="tooltipPosition"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon success">info</i>
    </ng-template>

    <ng-template ngSwitchCase="switch">
        <i [pTooltip]="buildTooltip(record)"
           [escape]="escape"
           [tooltipPosition]="tooltipPosition"
           [showDelay]="showDelay"
           [hideDelay]="hideDelay"
           [positionLeft]="positionLeft + tooltipOffsetX"
           [positionTop]="positionTop + tooltipOffsetY"
           class="material-icons tooltip-icon important-icon">swap_horiz</i>
    </ng-template>
</ng-container>
